import type { FC } from "react";

export type Props = {
  url: string;
};

const IFrameNode: FC<Props> = ({ url }) => <iframe title="iframe" src={url} />;

export default IFrameNode;
